// Mock data for the healthcare AI agent landing page

export const mockTestimonials = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    title: "Family Medicine Physician",
    practice: "Wellness Family Care Center",
    avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    quote: "Agents.audio transformed our patient management operations. We've seen a 60% reduction in missed appointments and our patient satisfaction scores increased dramatically. Patients love the instant appointment confirmations and aftercare reminders.",
    metrics: {
      metric1: "60% fewer no-shows",
      metric2: "4.8★ patient rating",
      metric3: "200+ positive reviews"
    }
  },
  {
    id: 2,
    name: "Dr. Michael Chen",
    title: "Internal Medicine Specialist",
    practice: "Comprehensive Care Clinic",
    avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=100&h=100&fit=crop&crop=face",
    rating: 5,
    quote: "The AI scheduling system understands our complex patient care protocols perfectly. It handles initial consultations, follow-up appointments, and aftercare scheduling seamlessly. Patients appreciate the 24/7 availability for non-urgent inquiries.",
    metrics: {
      metric1: "40% more bookings",
      metric2: "95% satisfaction rate",
      metric3: "24/7 availability"
    }
  }
];

export const mockStats = {
  appointmentsScheduled: 25000,
  reviewsCollected: 8500,
  practicesServed: 150,
  averageRating: 4.7,
  responseTime: "< 30 seconds",
  uptime: "99.9%"
};

export const mockPricingPlans = [
  {
    name: "Starter",
    price: 199,
    period: "month",
    description: "Perfect for small practices getting started with AI automation",
    features: [
      "AI appointment scheduling",
      "Basic review collection",
      "Email support",
      "Up to 500 appointments/month",
      "1 practice location",
      "Basic analytics"
    ],
    highlighted: false,
    cta: "Start Free Trial"
  },
  {
    name: "Professional",
    price: 399,
    period: "month",
    description: "Ideal for growing practices with advanced automation needs",
    features: [
      "Everything in Starter",
      "Advanced review automation",
      "Multi-channel communication",
      "Up to 2,000 appointments/month",
      "3 practice locations",
      "Advanced analytics",
      "Priority support",
      "Custom integrations"
    ],
    highlighted: true,
    cta: "Start Free Trial"
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "Tailored solutions for large healthcare organizations",
    features: [
      "Everything in Professional",
      "Unlimited appointments",
      "Unlimited locations",
      "White-label solution",
      "Dedicated account manager",
      "Custom AI training",
      "24/7 phone support",
      "SLA guarantee"
    ],
    highlighted: false,
    cta: "Contact Sales"
  }
];

export const mockFAQs = [
  {
    question: "How quickly can we get started with Agents.audio for our healthcare practice?",
    answer: "Most healthcare practices are up and running within 3-5 business days. Our team handles the technical setup and integration with your existing practice management systems, so there's minimal disruption to your patient care workflow."
  },
  {
    question: "Does Agents.audio integrate with popular healthcare management systems?",
    answer: "Yes! Agents.audio seamlessly integrates with popular healthcare systems like Epic, Cerner, Athenahealth, NextGen, and many others. Our team will ensure smooth integration during setup."
  },
  {
    question: "Is patient health information secure and HIPAA compliant?",
    answer: "Absolutely. Agents.audio is fully HIPAA compliant with enterprise-grade security. All patient health information is encrypted in transit and at rest, and we maintain strict access controls and audit logs specifically for healthcare data."
  },
  {
    question: "Can the AI handle complex patient management and aftercare scenarios?",
    answer: "Yes, our AI is trained on healthcare workflows and can handle complex scenarios like initial consultations, treatment plan coordination, follow-up appointments, aftercare instructions, medication reminders, and urgent care triage."
  },
  {
    question: "What if patients prefer to speak with a human about their health concerns?",
    answer: "Agents.audio can seamlessly transfer calls to your staff when requested or when the situation requires human intervention. The AI provides context about the patient's concerns and care history to ensure smooth handoffs."
  },
  {
    question: "How does the review collection work for healthcare patients?",
    answer: "Our AI analyzes patient interactions and care outcomes to identify satisfied patients who've had positive experiences. It then sends personalized review requests at optimal times via their preferred communication method, specifically mentioning their successful care outcome."
  }
];

export const mockSpecialties = [
  {
    name: "Primary Care",
    icon: "🏥",
    description: "Comprehensive patient management for family medicine and internal medicine",
    features: ["Preventive care scheduling", "Chronic disease management", "Wellness follow-ups"]
  },
  {
    name: "Specialist Practices", 
    icon: "👩‍⚕️",
    description: "Specialized aftercare and treatment coordination",
    features: ["Treatment series booking", "Progress monitoring", "Recovery follow-ups"]
  },
  {
    name: "Mental Health",
    icon: "🧠", 
    description: "Sensitive patient communication with therapy scheduling",
    features: ["Confidential scheduling", "Crisis support routing", "Therapy session reminders"]
  },
  {
    name: "Urgent Care",
    icon: "⚡",
    description: "Fast patient triage and emergency appointment coordination", 
    features: ["Symptom-based triage", "Emergency prioritization", "Rapid scheduling"]
  }
];